import { render, staticRenderFns } from "./DaftarGadai.vue?vue&type=template&id=3675f87e&scoped=true&"
import script from "./DaftarGadai.vue?vue&type=script&lang=js&"
export * from "./DaftarGadai.vue?vue&type=script&lang=js&"
import style0 from "./DaftarGadai.vue?vue&type=style&index=0&id=3675f87e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3675f87e",
  null
  
)

export default component.exports